
import { mapGetters } from "vuex";

import CommonHeaderMobile from "../../components/common/common-header-mobile.vue";
import AppReceiverConfiguration from "../../components/apps/app-receiver-configuration.vue";

export default {
  components: {
    CommonHeaderMobile,
    AppReceiverConfiguration,
    AppWhatsappConfiguration: () =>
      import("@/components/apps/app-whatsapp-configuration.vue")
  },
  computed: {
    ...mapGetters("reciever", ["isWhatsappAdded"]),

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }
};
